import Class from './c-content';
import './c-content@.vue';

export default Class;